import { render, staticRenderFns } from "./DonationDetails.vue?vue&type=template&id=b8455aca"
import script from "./DonationDetails.vue?vue&type=script&lang=js"
export * from "./DonationDetails.vue?vue&type=script&lang=js"
import style0 from "./DonationDetails.vue?vue&type=style&index=0&id=b8455aca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports